import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import { REACT_APP_BASE_SURVEY_URL } from '../../config/settings/environment'
import { Iframe, Root } from './Iframe.styles'

/**
 * The CustomIframe's component.
 */
const CustomIframe = ({ accessToken, origin, quoteCode }) => {
  const [iframeUrl, setIframeUrl] = useState('')
  const [showSurvey, setShowSurvey] = useState(false)

  const iframeRef = useRef(null)

  const params = new URLSearchParams({
    id: quoteCode,
    origin,
    access_token: accessToken
  })

  useEffect(() => {
    const fetchTokenAndSetUrl = async () => {
      setIframeUrl(`${REACT_APP_BASE_SURVEY_URL}/encuestas?${params}`)
    }

    fetchTokenAndSetUrl()
  }, [])

  useEffect(() => {
    const handleMessage = event => {
      if (event.data?.type === 'SURVEY_HEIGHT_UPDATE') {
        const newHeight = event.data.height

        if (iframeRef.current) {
          iframeRef.current.style.height = `${newHeight}px`
        }
      }

      if (event.data?.type === 'SHOW_SURVEY_FORM') {
        setShowSurvey(event.data.show)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
  }, [])

  return (
    <Root>
      <Iframe ref={iframeRef} scrolling="no" src={iframeUrl} style={{ display: showSurvey ? 'block' : 'none' }} />
    </Root>
  )
}

CustomIframe.propTypes = {
  accessToken: PropTypes.string.isRequired,
  origin: PropTypes.number.isRequired,
  quoteCode: PropTypes.string.isRequired
}

export default CustomIframe
